<div *ngIf="offersFiltered && !firstPage">
  <div *ngFor="let offer of pageOffers; let i = index">
    <!-- show only firt one - with biggest priotity -->
    <div *ngIf="i === 0" class="warning red" [ngClass]="['warning-' + i, class ? class : '']">
      <p [innerHTML]="getOfferHeaderText(offer) | safeHtml" (click)="showConditionsModal(offer)"></p>
    </div>
  </div>
</div>
